<aeg-datatable :value="invoiceRounds" :loading="isLoading">
    <template #empty>
        Er zijn nog geen facturatierondes.
    </template>
    <Column header="Datum" :field="(invoiceRound) => formatDateTime(invoiceRound.date)" />
    <Column header="Facturatieperiode" :field="(invoiceRound) => `${formatDate(invoiceRound.startDate)} - ${formatDate(invoiceRound.endDate)}`" />
    <Column header="Service" field="service" body-class="aeg-uppercase" />
    <Column header="Status" field="state" />
    <Column header="Type" field="type" />
    <Column header="Aantal facturen" field="invoiceCount" />
</aeg-datatable>
